// file for handling the top filters.
//Import Libraries
import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useState } from "react";
import { withRouter } from "react-router";
import { Grid } from "@material-ui/core";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Dropdown from "../../../components/Dropdown/Dropdown";
import { config } from "../../../config/config";
import { updateAlert, updateSourceInputs } from "../../../redux/actions";
import { InputLabel } from "@material-ui/core";
import "./templateview.scss";
import Loader from "../../../components/Loader/Loader";
import CustomSelect from "../../../components/input/select";
import FileUpload from "../../../components/FileUpload/FileUpload";
import GlobalDropZone from "../../../components/FileUpload/GlobalDropZone";
import { useUserAuthentication } from "../../../utils/utils";
import { useHistory } from "react-router-dom";

let api = config.api.api_url;

function MetaSearchFilter(props) {
  let {
    user,
    source_data,
    tableLoading,
    updateSourceInputs,
    loading,
    setMappedData,
    setMappedDataCreateNew,
    updateAlert,
    isPlaceholderFetching,
    setIsPlaceholderFetching,
  } = props;
  const [expand, setExpand] = useState(false);
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [isFilterLoading, setIsFilterLoading] = useState(false);
  const [isSffLoading, setIsSffLoading] = useState(false);
  const { login } = useUserAuthentication();
  let history = useHistory();

  const isCreateNewVisible = useMemo(() => {
    if (
      source_data.current_filter_value === "Create new" &&
      source_data.current_filter_value !== ""
    ) {
      return false;
    }
    return (
      source_data.current_source === "" ||
      isFilterLoading == true ||
      isButtonLoading == true
    );
  }, [
    source_data,
    source_data.current_source,
    source_data.current_filter_value,
    isFilterLoading,
    isButtonLoading,
  ]);

  const isExistingVisible = useMemo(() => {
    if (
      source_data.current_filter_value === "Existing" &&
      source_data.current_filter_value !== ""
    ) {
      return false;
    }
    return (
      source_data.current_source == "" ||
      isFilterLoading == true ||
      isButtonLoading == true
    );
  }, [
    source_data,
    source_data.current_source,
    source_data.current_filter_value,
    isFilterLoading,
    isButtonLoading,
  ]);

  const has_Awaiting_Data = useMemo(() => {
    const data = source_data?.has_awaiting_data;

    if (!data) return false;

    const { has_records, has_access } = data;

    return !has_records || (has_records && has_access);
  }, [source_data.has_awaiting_data]);

  const is_Approver = useMemo(() => {
    const Is_Role_Approver = user?.role && user?.role?.includes("AppApprover");
    const URL = history?.location?.pathname || [];
    const result = URL.split("/").pop();
    const is_Approver_For_This_Usecase =
      user?.approval_screens && user?.approval_screens?.includes(result);
    return Is_Role_Approver && is_Approver_For_This_Usecase;
  }, [user.role, user.approval_screens]);

  let result = [];
  let sourceOptions = [];
  let SSF_FILE_options = [];

  // FETCH META DATA FOR SELECTED DATASET
  const handleSourceChange = async (e, selectedOption) => {
    updateSourceInputs("current_source", selectedOption.value);
    updateSourceInputs("current_source_label", selectedOption.label);
    updateSourceInputs("is_initial", true);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("current_country", "");
    updateSourceInputs("current_country_code", "");
    updateSourceInputs("current_filter_value", "");
    updateSourceInputs("current_ssfFileId", "");

    try {
      const params = new URLSearchParams({
        dataset_name: selectedOption.value || "",
      });
      // code for initial data fetching
      const response = await fetch(api + `/template/getmetadata?${params}`, {
        method: "GET",
        mode: "cors",
        credentials: "include",
        headers: {
          Authorization: `Bearer ${user.token || ""}`,
          "Content-Type": "application/json",
        },
      });

      const responseJson = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (responseJson?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      const Data = responseJson.data;
      const Metadata_Filters = Data.metadata_filter;
      const File_ID = Data[Metadata_Filters[1]];

      const { COUNTRY, ...data } = Data;

      const countryOptions =
        COUNTRY?.filter(
          (country) =>
            country !== null && country !== undefined && country !== "",
        )?.map((country) => ({
          label: country.COUNTRY,
          value: country.country_code,
        })) ?? [];

      const SourceData = {
        ...source_data.data,
        dropdown: {
          ...data,
          [Metadata_Filters[1]]: File_ID,
        },
      };

      updateSourceInputs("current_mapped_country", []);
      updateSourceInputs("master_table_countries", countryOptions);
      updateSourceInputs("current_ssf_file_id", File_ID);
      updateSourceInputs("data", SourceData);
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "Failed ",
        closeFlag: true,
      });
    }
  };

  // FETCH COUNTRIES FOR CHOSEN FILTER TYPE
  const handleRadioChange = async (e) => {
    setIsFilterLoading(true);
    updateSourceInputs("is_initial", true);
    updateSourceInputs("current_filter_value", e.target.value);
    updateSourceInputs("current_country", "");
    updateSourceInputs("current_country_code", "");
    updateSourceInputs("current_ssfFileId", "");

    let NEW_COUNTRIES;
    try {
      const params = new URLSearchParams({
        dataset_name: source_data?.current_source || "",
        filter_type: e.target.value === "Existing" ? "existing" : "create",
      });
      const response = await fetch(api + `/template/getcountries?${params}`, {
        method: "GET",
        mode: "cors",
        credentials: "include",
        headers: {
          Authorization: `Bearer ${user.token || ""}`,
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }
      if (data && data.data) {
        NEW_COUNTRIES = data?.data || [];
      }

      const countryOptions =
        NEW_COUNTRIES?.filter(
          (country) =>
            country !== null && country !== undefined && country !== "",
        )
          ?.filter((cntry) => cntry != null) // filters out null and undefined
          .map((country) => ({
            label: country,
            value: country,
          })) ?? [];

      updateSourceInputs("current_mapped_country", countryOptions);
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "Failed ",
        closeFlag: true,
      });
    }

    setIsFilterLoading(false);
  };

  // FETCH SFF_FILE_ID'S FOR SELECTED COUNTRY
  const handleCountryChange = async (e, selectedOption) => {
    setIsSffLoading(true);
    updateSourceInputs("is_initial", true);
    updateSourceInputs("current_country", selectedOption.label);
    updateSourceInputs("current_country_code", selectedOption.value);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("current_ssfFileId", "");
    updateSourceInputs("current_ssf_file_id", []);
    const Country_Code = source_data.master_table_countries.find(
      (item) =>
        item.label.toUpperCase() === selectedOption.label ||
        item.value.toUpperCase() === selectedOption.label,
    );

    // API call to get Updated SFF_File_Id based on Filter
    let NEW_SFF_FILE_IDS;
    try {
      const params = new URLSearchParams({
        country: selectedOption.label || "",
        type:
          source_data?.current_filter_value === "Existing"
            ? "existing"
            : "create",
        country_code: Country_Code.value || "",
        dataset_name: source_data?.current_source || "",
      });
      const response = await fetch(
        api + `/template/get_sff_file_id?${params}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        },
      );
      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }
      if (data && data.data) {
        NEW_SFF_FILE_IDS = data?.data || [];
      }

      const UPDATED_NEW_SFF_FILE_IDS =
        Array.isArray(NEW_SFF_FILE_IDS) &&
        NEW_SFF_FILE_IDS.length === 1 &&
        NEW_SFF_FILE_IDS[0] === ""
          ? []
          : (NEW_SFF_FILE_IDS?.filter(
              (country) =>
                country !== null && country !== undefined && country !== "",
            )?.map((item) => {
              return { label: item, value: item };
            }) ?? []);

      updateSourceInputs("current_ssf_file_id", UPDATED_NEW_SFF_FILE_IDS);
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "Failed ",
        closeFlag: true,
      });
      return;
    }
    setIsSffLoading(false);
  };

  // FETCH TABLE DATA FOR SELECTED SFF_FILE_ID
  const handleSSFFileChange = async (e, selectedOption) => {
    setIsButtonLoading(false);
    updateSourceInputs("is_initial", true);
    updateSourceInputs("is_table_loading", true);
    updateSourceInputs("current_ssfFileId", selectedOption.value);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("searchValue", "");
    updateSourceInputs("filtered_Rows", []);
    updateSourceInputs("appliedFilters", []);
    updateSourceInputs("any_row_isEditing", false);
    updateSourceInputs("is_file_uploaded", false);

    const Country_Code = source_data.master_table_countries.find(
      (item) =>
        item.label.toUpperCase() === source_data.current_country ||
        item.value.toUpperCase() === source_data.current_country_code,
    );

    // fetch PLACEHOLDER_DATA if "Create new" is selected
    if (source_data.current_filter_value !== "Create new") {
      setMappedData(
        source_data.current_source,
        source_data.current_country,
        Country_Code ? Country_Code.value : source_data.current_country,
        selectedOption.value,
      );
    } else {
      setMappedDataCreateNew(
        source_data.current_source,
        source_data.current_country,
        Country_Code ? Country_Code.value : source_data.current_country,
        selectedOption.value,
      );
    }
  };

  //for getting the dataset name from redux and map it into array.
  if (source_data.data && source_data?.data?.data) {
    result =
      source_data?.data?.data &&
      source_data?.data?.data.map((data) => {
        return data.toString();
      });

    sourceOptions =
      result &&
      result.map((data) => {
        return { label: data, value: data };
      });
  }

  // GET PLACEHOLDER DATA FOR SELECTED SFF_FILE_ID - ONLY FOR CREATE NEW FILTER
  const handlePlaceholderFile = () => {
    updateSourceInputs("is_initial", false);
    updateSourceInputs("is_table_loading", false);
  };

  // FETCHES VERSION DETAILS - ONLY FOR EXISTING FILTER
  const handleVersionsFilter = async (e) => {
    updateSourceInputs("is_initial", true);
    updateSourceInputs("is_table_loading", false);
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("searchValue", "");
    updateSourceInputs("filtered_Rows", []);
    updateSourceInputs("appliedFilters", []);

    const Country_Code = source_data.master_table_countries.find(
      (item) =>
        item.label.toUpperCase() === source_data.current_country ||
        item.value.toUpperCase() === source_data.current_country_code,
    );

    if (e.target.value === "Latest") {
      setMappedData(
        source_data.current_source,
        source_data.current_country,
        Country_Code ? Country_Code.value : source_data.current_country,
        source_data.current_ssfFileId,
        source_data.current_filter_value,
        "default",
      );
    } else {
      try {
        const params = new URLSearchParams({
          dataset_name: source_data.current_source || "",
          country: source_data.current_country || "",
          file_id: source_data.current_ssfFileId || "",
          filtertype: "initial_fetch",
        });
        const response = await fetch(
          api + `/template/fetchversion/new?${params}`,
          {
            method: "GET",
            mode: "cors",
            credentials: "include",
            headers: {
              Authorization: `Bearer ${user.token || ""}`,
              "Content-Type": "application/json",
            },
          },
        );

        if (!response.ok) {
          throw new Error(`Unexpected error occured. Please try again later`);
        }

        const data = await response.json();

        // Check if response is OK before trying to parse it
        if (!response.ok) {
          if (data?.statusCode === "harbor-401") {
            updateAlert({
              open: true,
              message: `User Unauthorized. Please sign in.`,
              severity: "warning",
              closeFlag: true,
            });
            login(); // or redirect to login
            return;
          } else {
            throw new Error(`Unexpected error occured. Please try again later`);
          }
        }

        const Version_Data = data?.data ?? [];

        if (Version_Data.length === 0) {
          updateAlert({
            open: true,
            message: "No data found. Please try again.",
            severity: "Failed", // Use 'warning' or 'info' instead of 'Failed'
            closeFlag: true,
          });
          return;
        }

        let count = Version_Data.filter(
          (version) => version?.UPDATED_AT != null,
        ).length;
        const Sorted_Version_Data = Version_Data.filter(
          (version) => version?.UPDATED_AT != null,
        ).map((version) => {
          const updatedAt = version.UPDATED_AT;

          return {
            label: `V${count--} - ${updatedAt}`,
            value: updatedAt,
          };
        });
      } catch (err) {
        updateAlert({
          open: true,
          message: `Unexpected error occured. Please try again later`,
          severity: "Failed",
          closeFlag: true,
        });
      }
    }
  };

  // FETCHES TABLE DATA FOR SELECTED VERSION - ONLY FOR EXISTING FILTER
  const handleVersionSelect = (e) => {
    const Country_Code = source_data.master_table_countries.find(
      (item) =>
        item.label.toUpperCase() === source_data.current_country ||
        item.value.toUpperCase() === source_data.current_country_code,
    );
    setMappedData(
      source_data.current_source,
      source_data.current_country,
      Country_Code ? Country_Code.value : source_data.current_country,
      source_data.current_ssfFileId,
      source_data.current_filter_value,
      e.value,
    );
  };

  return (
    <>
      {!is_Approver && (
        <div className="cnc-toggle-icon">
          <label
            onClick={() => {
              setExpand(!expand);
            }}
          >
            {!expand ? "Collapse" : "Expand"}
          </label>
          <i
            className="material-icons"
            onClick={() => {
              setExpand(!expand);
            }}
          >
            {!expand ? "keyboard_arrow_up" : "keyboard_arrow_down"}
          </i>
        </div>
      )}

      {!expand && (
        <div className="cnc-model-header-mapping">
          <Grid container spacing={2} style={{ padding: "2px 15px 0px 15px" }}>
            <>
              {/* DATASETS */}
              <Grid item xs={3} sm={3}>
                <div
                  className="mg-model-header-item"
                  style={{ height: "25px" }}
                >
                  Select Dataset:{" "}
                  <p
                    style={{
                      display: "inline",
                      color: "red",
                      fontSize: 16,
                    }}
                  >
                    *
                  </p>
                </div>
                <div className="" style={{ marginBottom: "15px" }}>
                  <Autocomplete
                    id="country-select"
                    disableClearable
                    size="small"
                    options={source_data.current_mapped_source}
                    loading={
                      loading &&
                      (source_data.current_mapped_source ||
                        source_data.current_mapped_source.length === 0)
                    }
                    loadingText={<Loader />}
                    getOptionLabel={(option) => option.label}
                    onChange={handleSourceChange}
                    value={
                      source_data.current_source &&
                      source_data.current_source.length > 0
                        ? {
                            label: source_data.current_source_label,
                            value: source_data.current_source_label,
                          }
                        : null
                    }
                    popupIcon={
                      <span
                        className="material-icons"
                        style={{
                          fontSize: "20px",
                          color:
                            source_data.current_source === ""
                              ? "f7f7f7"
                              : "#555",
                        }}
                      >
                        arrow_drop_down
                      </span>
                    }
                    sx={{
                      width: "100%",
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "#fff",
                        fontFamily: "Hind Siliguri",
                        borderRadius: "6px",
                        fontSize: "13px",
                        fontWeight: "400",
                        color: "#333",
                        height: "36px",
                        paddingRight: "36px", // space for dropdown icon
                      },
                      "& .MuiOutlinedInput-input": {
                        padding: "8px 12px",
                      },
                      "& .MuiAutocomplete-endAdornment": {
                        right: "12px",
                        top: "50%",
                        transform: "translateY(-50%)", // vertical center alignment
                      },
                      "& .MuiSvgIcon-root": {
                        color: "#999",
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        // label="Select Country"
                        InputLabelProps={{
                          style: {
                            fontSize: "13px",
                          },
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li
                        {...props}
                        style={{
                          fontSize: "12px",
                          fontWeight: "normal",
                          color: "#212529",
                        }}
                      >
                        {option.label}
                      </li>
                    )}
                  />
                </div>
              </Grid>

              {/* FILTERS - CREATE NEW OR EXISTING */}
              <Grid item xs={3} sm={3}>
                <div
                  className="mg-model-header-item"
                  style={{ height: "25px" }}
                >
                  Choose Filter:{" "}
                  <p
                    style={{
                      display: "inline",
                      color: "red",
                      fontSize: 16,
                    }}
                  >
                    *
                  </p>
                </div>
                <div
                  className="radio-input-container"
                  style={{ marginBottom: "15px" }}
                >
                  {/* Insert New */}
                  <div className="radio-input-div">
                    <input
                      id="all-checkbox"
                      type="radio"
                      value="Create new"
                      disabled={isCreateNewVisible ? true : false}
                      name="filter"
                      checked={
                        source_data.current_filter_value === "Create new"
                      }
                      onChange={handleRadioChange}
                      className="radio-checkbox-label"
                    />
                    <InputLabel
                      htmlFor={"all-checkbox"}
                      className="radio-checkbox-label"
                    >
                      Create new
                    </InputLabel>
                  </div>

                  {/* Existing */}
                  <div className="radio-input-div">
                    <input
                      id="Unmapped-checkbox"
                      type="radio"
                      value="Existing"
                      disabled={isExistingVisible ? true : false}
                      name="filter"
                      checked={source_data.current_filter_value === "Existing"}
                      onChange={handleRadioChange}
                      className="radio-checkbox-label"
                    />
                    <InputLabel
                      htmlFor={"Unmapped-checkbox"}
                      className="radio-checkbox-label"
                    >
                      Existing
                    </InputLabel>
                  </div>
                </div>
              </Grid>

              {isFilterLoading && <Loader />}

              {/* COUNTRY */}
              {source_data.current_filter_value !== "" &&
                !isFilterLoading &&
                (source_data.current_mapped_country.length > 0 ? (
                  <Grid item xs={3} sm={3}>
                    <div
                      className="mg-model-header-item"
                      style={{ height: "25px" }}
                    >
                      Select Country:{" "}
                      <p
                        style={{
                          display: "inline",
                          color: "red",
                          fontSize: 16,
                        }}
                      >
                        *
                      </p>
                    </div>
                    <div className="" style={{ marginBottom: "15px" }}>
                      <Autocomplete
                        disabled={
                          source_data.current_source === "" || loading == true
                            ? true
                            : false
                        }
                        id="country-select"
                        disableClearable
                        size="small"
                        options={source_data.current_mapped_country}
                        getOptionLabel={(option) => option.label}
                        onChange={handleCountryChange}
                        defaultValue={
                          {
                            label: source_data.current_country,
                            value: source_data.current_country_code,
                          } || null
                        }
                        popupIcon={
                          <span
                            className="material-icons"
                            style={{
                              fontSize: "20px",
                              color:
                                source_data.current_source === ""
                                  ? "f7f7f7"
                                  : "#555",
                            }}
                          >
                            arrow_drop_down
                          </span>
                        }
                        sx={{
                          width: "100%",
                          "& .MuiOutlinedInput-root": {
                            backgroundColor: "#fff",
                            fontFamily: "Hind Siliguri",
                            borderRadius: "6px",
                            fontSize: "13px",
                            fontWeight: "400",
                            color: "#333",
                            height: "36px",
                            paddingRight: "36px", // space for dropdown icon
                          },
                          "& .MuiOutlinedInput-input": {
                            padding: "8px 12px",
                          },
                          "& .MuiAutocomplete-endAdornment": {
                            right: "12px",
                            top: "50%",
                            transform: "translateY(-50%)", // vertical center alignment
                          },
                          "& .MuiSvgIcon-root": {
                            color: "#999",
                          },
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            // label="Select Country"
                            InputLabelProps={{
                              style: {
                                fontSize: "13px",
                              },
                            }}
                          />
                        )}
                        renderOption={(props, option) => (
                          <li
                            {...props}
                            style={{
                              fontSize: "12px",
                              fontWeight: "normal",
                              color: "#212529",
                            }}
                          >
                            {option.label}
                          </li>
                        )}
                      />
                    </div>
                  </Grid>
                ) : (
                  <div className="no_data_found">No Data Found</div>
                ))}

              {isSffLoading && <Loader />}

              {/* SFF FILE ID  */}
              {source_data.current_country !== "" &&
                !isSffLoading &&
                (source_data.current_ssf_file_id.length > 0 ? (
                  <Grid item xs={3} sm={3}>
                    <div
                      className="mg-model-header-item"
                      style={{ height: "25px" }}
                    >
                      Select SFF File ID:{" "}
                      <p
                        style={{
                          display: "inline",
                          color: "red",
                          fontSize: 16,
                        }}
                      >
                        *
                      </p>
                    </div>
                    <div className="" style={{ marginBottom: "15px" }}>
                      <Autocomplete
                        id="country-select"
                        disableClearable
                        size="small"
                        options={source_data.current_ssf_file_id}
                        loading={
                          loading &&
                          (source_data.current_mapped_source ||
                            source_data.current_mapped_source.length === 0)
                        }
                        disabled={
                          loading &&
                          (!source_data.current_country ||
                            source_data.current_country.length === 0)
                        }
                        loadingText={<Loader />}
                        getOptionLabel={(option) => option.label}
                        onChange={handleSSFFileChange}
                        value={
                          source_data.current_ssfFileId &&
                          source_data.current_ssfFileId.length > 0
                            ? {
                                label: source_data.current_ssfFileId,
                                value: source_data.current_ssfFileId,
                              }
                            : null
                        }
                        popupIcon={
                          <span
                            className="material-icons"
                            style={{
                              fontSize: "20px",
                              color:
                                source_data.current_source === ""
                                  ? "f7f7f7"
                                  : "#555",
                            }}
                          >
                            arrow_drop_down
                          </span>
                        }
                        sx={{
                          width: "100%",
                          "& .MuiOutlinedInput-root": {
                            backgroundColor:
                              source_data.current_country === ""
                                ? "#d6d6d6"
                                : "#fff",
                            fontFamily: "Hind Siliguri",
                            borderRadius: "6px",
                            fontSize: "13px",
                            fontWeight: "400",
                            color: "#333",
                            height: "36px",
                            paddingRight: "36px", // space for dropdown icon
                          },
                          "& .MuiOutlinedInput-input": {
                            padding: "8px 12px",
                          },
                          "& .MuiAutocomplete-endAdornment": {
                            right: "12px",
                            top: "50%",
                            transform: "translateY(-50%)", // vertical center alignment
                          },
                          "& .MuiSvgIcon-root": {
                            color: "#999",
                          },
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            // label="Select Country"
                            InputLabelProps={{
                              style: {
                                fontSize: "13px",
                              },
                            }}
                          />
                        )}
                        renderOption={(props, option) => (
                          <li
                            {...props}
                            style={{
                              fontSize: "12px",
                              fontWeight: "normal",
                              color: "#212529",
                            }}
                          >
                            {option.label}
                          </li>
                        )}
                      />
                    </div>
                  </Grid>
                ) : (
                  <div className="no_data_found">No Data Found</div>
                ))}
            </>
          </Grid>
        </div>
      )}

      {isPlaceholderFetching && <Loader />}

      {/* FILE UPLOAD OR PLACEHOLDER SELECTION */}
      {!expand &&
        !isPlaceholderFetching &&
        !props.isFileUploading &&
        source_data.is_initial &&
        source_data.is_table_loading &&
        has_Awaiting_Data && (
          <div
            style={{
              display: "flex",
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            {source_data.current_ssfFileId !== "" && (
              <div
                style={{ display: "flex", alignItems: "center", gap: "15px" }}
              >
                <div>
                  <GlobalDropZone
                    updateAlert={props.updateAlert}
                    handleFileUpload={props.handleFileUpload}
                    requiredColumns={props.requiredColumns}
                  />
                  <FileUpload
                    updateAlert={props.updateAlert}
                    handleFileUpload={props.handleFileUpload}
                    isFileUploading={props.isFileUploading}
                    requiredColumns={
                      source_data?.data?.dropdown?.download_sample_columns || []
                    }
                    source_Data={source_data}
                    updateSourceInputs={updateSourceInputs}
                    user={user}
                  />
                </div>
                <span>Or</span>
                <button
                  onClick={handlePlaceholderFile}
                  className="sample-button"
                >
                  Proceed with Existing Template
                </button>
              </div>
            )}
          </div>
        )}
    </>
  );
}

MetaSearchFilter.propTypes = {
  user: PropTypes.object,
  userData: PropTypes.object,
  source_data: PropTypes.object,
  cncData: PropTypes.object,
  brand_data: PropTypes.object,
  updateSourceInputs: PropTypes.func,
};

const mapStateToProps = (state) => ({
  user: state.user,
  cncData: state.cncinputs,
  source_data: state.source,
});

const mapDispatchToProps = {
  updateSourceInputs,
  updateAlert,
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MetaSearchFilter),
);
